import service from '../utils/request';

// 获取支付接口列表
export const getPaymentInterfaceList = () => {
  return service.get('/payment-interfaces/list');
};

// 获取支付接口详情
export const getPaymentInterfaceDetail = (id) => {
  return service.get(`/payment-interfaces/${id}`);
};

// 创建支付接口
export const createPaymentInterface = (data) => {
  return service.post('/payment-interfaces', data);
};

// 更新支付接口
export const updatePaymentInterface = (id, data) => {
  return service.put(`/payment-interfaces/${id}`, data);
};

// 删除支付接口
export const deletePaymentInterface = (id) => {
  return service.delete(`/payment-interfaces/${id}`);
};

// 启用支付接口
export const enablePaymentInterface = (id) => {
  return service.put(`/payment-interfaces/${id}/enable`);
};

// 禁用支付接口
export const disablePaymentInterface = (id) => {
  return service.put(`/payment-interfaces/${id}/disable`);
}; 